import React, { useState } from "react";
import { Card, Button, Row, Col, Spinner, FormGroup, Input } from "reactstrap";
import { deleteCommissionStructure } from "../../../slices/national/thunk";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { formatCentsToDollars } from "../../../utils/utils";
import AddCommissionStructureModal from "./modals/AddCommissionStructureModal";
import EditCommissionStructure from "./modals/EditCommissionStructure";

const CommissionsStructure = ({
  nationalId,
  commissionsStructure,
  loading,
  onRefresh,
  totalAmount,
}) => {
  if (loading)
    return (
      <div className="d-flex justify-content-center align-items-center">
        <Spinner color="primary" />
      </div>
    );

  console.log("commissionsStructure", commissionsStructure);

  const dispatch = useDispatch();
  const [loadingSelect, setLoadingSelect] = useState(null);

  const [openModalEditCommission, setOpenModalEditCommission] = useState(false);

  const toggleModalEditCommission = () =>
    setOpenModalEditCommission(!openModalEditCommission);

  const [selectedCommission, setSelectedCommission] = useState(
    commissionsStructure?.current?.id
  );
  const [tempSelectedCommission, setTempSelectedCommission] = useState(
    commissionsStructure?.current?.id
  );
  const selectedStructure =
    commissionsStructure?.custom?.find(
      (structure) => structure.id === selectedCommission
    ) || commissionsStructure?.default;

  // Only if it's custom
  const isCurrentDeletable =
    selectedCommission !== commissionsStructure?.current?.id;

  const handleDeleteCommissionStructure = async () => {
    const result = await Swal.fire({
      title: "Confirmation",
      // text: `Are you sure you want to delete the structure ${selectedStructure?.name}?`,
      html: `<p>Are you sure you want to delete the structure <strong>${selectedStructure?.name}</strong>?</p>
      <p>If you delete this commission structure, any entity that is currently assigned this will change to the default commission structure</p>
      <label>
        <input type="checkbox" id="deleteCheckbox" /> I understand
      </label>`,
      // input: "checkbox",
      // inputValue: 0,
      // inputPlaceholder: "I understand the consequences",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it",
      cancelButtonText: "Cancel",
      preConfirm: () => {
        const checkbox = document.getElementById("deleteCheckbox");
        if (!checkbox.checked) {
          Swal.showValidationMessage("You must check the box to confirm.");
          return false;
        }
        return true;
      },
      didOpen: () => {
        const confirmButton = Swal.getConfirmButton();
        const checkbox = document.getElementById("deleteCheckbox");

        // Initially disable the confirm button
        confirmButton.disabled = true;

        // Enable/disable the confirm button based on the checkbox state
        checkbox.addEventListener("change", () => {
          confirmButton.disabled = !checkbox.checked;
        });
      },
    });

    if (!result.isConfirmed || !result?.value) return;

    try {
      setLoadingSelect(tempSelectedCommission);
      console.log(tempSelectedCommission);
      const response = await dispatch(
        deleteCommissionStructure({
          nationalId,
          commissionStructureId: tempSelectedCommission,
        })
      );

      if (response && response.payload && !response.error) {
        setTempSelectedCommission(commissionsStructure?.default?.id);
        onRefresh();

        Swal.fire({
          title: "Deleted!",
          text: "Commission structure deleted successfully",
          icon: "success",
          confirmButtonText: "OK",
        });
      } else {
        Swal.fire({
          title: "Error!",
          text: "Error deleting commission structure",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
      setLoadingSelect(null);
    } catch (error) {
      console.log(error);
      Swal.fire({
        title: "Error!",
        text: "Error deleting commission structure",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
    setLoadingSelect(null);
  };

  return (
    <Col md={6}>
      <EditCommissionStructure
        nationalId={nationalId}
        onRefresh={onRefresh}
        commission={selectedStructure}
        isOpen={openModalEditCommission}
        setIsOpen={setOpenModalEditCommission}
        totalAmountCommission={totalAmount}
      />
      {selectedStructure && (
        <Card className="p-3 border rounded-4">
          <FormGroup>
            {loadingSelect ? (
              <div className="border py-2 rounded">
                <Spinner size="sm" color="primary" className="ms-4" />
              </div>
            ) : (
              <Input
                type="select"
                id="commissionSelect"
                value={tempSelectedCommission || ""}
                onChange={(e) => {
                  setTempSelectedCommission(e.target.value);
                  setSelectedCommission(e.target.value);
                }}
              >
                <option value={commissionsStructure?.default?.id || "default"}>
                  Default Commission Structure
                </option>
                {commissionsStructure?.custom?.map((structure) => (
                  <option key={structure.id} value={structure.id}>
                    {structure.name}
                  </option>
                ))}
              </Input>
            )}
          </FormGroup>
          <hr className="mt-0" />
          <Row>
            <Col>
              <p>
                National:{" "}
                <strong>
                  ${formatCentsToDollars(selectedStructure?.national)}
                </strong>
              </p>
              <p>
                GA:{" "}
                <strong>${formatCentsToDollars(selectedStructure?.ga)}</strong>
              </p>
              <p>
                Broker:{" "}
                <strong>
                  ${formatCentsToDollars(selectedStructure?.broker)}
                </strong>
              </p>
            </Col>
            <Col className="text-end">
              {/* {selectedStructure?.id === commissionsStructure?.default?.id && ( */}
              <Button
                onClick={() => toggleModalEditCommission()}
                className="btn btn-soft-primary border-primary"
                size="sm"
              >
                Edit
              </Button>
              {/* )} */}
              {isCurrentDeletable && (
                <Button
                  //   disabled={}
                  onClick={() => handleDeleteCommissionStructure()}
                  className={`btn btn-soft-primary border-primary ms-2 ${loadingSelect === tempSelectedCommission && "d-none"
                    }`}
                  size="sm"
                >
                  Delete
                </Button>
              )}
            </Col>
          </Row>
          {loadingSelect === selectedStructure?.id && <Spinner size="sm" />}
        </Card>
      )}
    </Col>
  );
};

export default CommissionsStructure;
